import { useTranslation } from 'react-i18next';
import { ConnectedAccountsLanding } from '@/components/ConnectedAccounts/ConnectedAccountsLanding';
import { DocumentTitle } from '@/components/Ui/DocumentTitle';
import { useLanguageAwareRouting } from '@/hooks/useLanguageAwareRouting';
import { markAccountDeleted } from '@/lib/account-deleted';
import { useRustyState } from '../../state';

export function AccountConnectedAccountsLandingPage() {
  const { t } = useTranslation();
  const { api } = useRustyState.getState();
  const { createLanguageURL } = useLanguageAwareRouting();
  const profilePath = createLanguageURL('/account/security');
  const addressesPath = createLanguageURL('/account/addresses');

  return (
    <>
      <DocumentTitle title={t('security.pageTitle')} />
      <ConnectedAccountsLanding
        api={api}
        connectedAccountsHref={`#${profilePath}`}
        addressesHref={`#${addressesPath}`}
        onDone={(to) => {
          window.location.hash = to === 'addresses' ? addressesPath : profilePath;
        }}
        onDeleted={async () => {
          markAccountDeleted();
          // The server ended the session with the account; a logout call would only 401.
          await useRustyState.getState().clearLocalSession();
          window.location.replace(`#${createLanguageURL('/')}`);
        }}
      />
    </>
  );
}
